var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaystore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 48,
    viewBox: "0 0 123 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.744946,
    y: 0.744946,
    width: 121.613,
    height: 46.857,
    rx: 7.05649,
    stroke: "#0A1853",
    strokeWidth: 0.510108
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_481_2889)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8747 14.0382C12.8747 13.5658 12.986 13.21 13.159 12.9699L24.0321 24.1982C24.0555 24.2224 24.0686 24.2547 24.0686 24.2883C24.0686 24.3219 24.0555 24.3542 24.0321 24.3784L13.1586 35.6062C12.9858 35.3662 12.8747 35.0112 12.8747 34.5384V14.0382Z",
    stroke: "#0A1853",
    strokeWidth: 0.409632
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.016 27.9957L24.5147 24.3785C24.4913 24.3544 24.4783 24.3221 24.4783 24.2884C24.4783 24.2548 24.4913 24.2225 24.5147 24.1984L28.016 20.583L32.3531 23.1275C32.9414 23.4728 33.1925 23.9006 33.1925 24.289C33.1925 24.6775 32.9414 25.1055 32.353 25.4513L28.016 27.9957Z",
    stroke: "#0A1853",
    strokeWidth: 0.409632
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_481_2889)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3798 35.8306L24.2719 24.5826L27.7353 28.1588L14.8469 35.7214C14.2234 36.0864 13.7155 36.0716 13.3798 35.8306Z",
    stroke: "#0A1853",
    strokeWidth: 0.409632
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.8467 12.8561L14.8467 12.8561L27.7353 20.4178L24.2728 23.9949L13.3798 12.747C13.7155 12.5057 14.2235 12.4904 14.8467 12.8561Z",
    stroke: "#0A1853",
    strokeWidth: 0.409632
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.5689 25.41C59.5748 25.41 57.9495 26.9694 57.9495 29.117C57.9495 31.2516 59.5748 32.824 61.5689 32.824C63.5639 32.824 65.1892 31.2516 65.1892 29.117C65.1883 26.9694 63.563 25.41 61.5689 25.41ZM61.5689 31.3649C60.476 31.3649 59.5341 30.4384 59.5341 29.1179C59.5341 27.7834 60.4769 26.8709 61.5689 26.8709C62.6618 26.8709 63.6037 27.7834 63.6037 29.1179C63.6037 30.4375 62.6618 31.3649 61.5689 31.3649ZM53.6722 25.41C51.6781 25.41 50.0528 26.9694 50.0528 29.117C50.0528 31.2516 51.6781 32.824 53.6722 32.824C55.6671 32.824 57.2924 31.2516 57.2924 29.117C57.2924 26.9694 55.6671 25.41 53.6722 25.41ZM53.6722 31.3649C52.5793 31.3649 51.6374 30.4384 51.6374 29.1179C51.6374 27.7834 52.5802 26.8709 53.6722 26.8709C54.765 26.8709 55.707 27.7834 55.707 29.1179C55.7078 30.4375 54.765 31.3649 53.6722 31.3649ZM44.2798 26.5484V28.1208H47.9408C47.8314 29.0055 47.5449 29.6513 47.1074 30.1002C46.5749 30.6476 45.7415 31.2516 44.2798 31.2516C42.0263 31.2516 40.2645 29.3837 40.2645 27.067C40.2645 24.7502 42.0263 22.8823 44.2798 22.8823C45.4956 22.8823 46.3833 23.3739 47.0387 24.0059L48.118 22.8963C47.2023 21.9976 45.9874 21.3099 44.2798 21.3099C41.1929 21.3099 38.5977 23.8934 38.5977 27.067C38.5977 30.2405 41.1929 32.824 44.2798 32.824C45.9458 32.824 47.2032 32.2618 48.1858 31.2089C49.1964 30.1699 49.511 28.7091 49.511 27.5298C49.511 27.1655 49.4839 26.8281 49.4288 26.5475L44.2798 26.5484ZM82.6936 27.7695C82.3934 26.9415 81.4778 25.41 79.6066 25.41C77.749 25.41 76.2051 26.9127 76.2051 29.117C76.2051 31.195 77.7354 32.824 79.7838 32.824C81.4362 32.824 82.3926 31.785 82.7894 31.181L81.56 30.3382C81.1505 30.9561 80.5901 31.3632 79.7838 31.3632C78.9784 31.3632 78.4044 30.984 78.0356 30.2397L82.8572 28.1896L82.6936 27.7695ZM77.7761 29.0055C77.7354 27.5725 78.8554 26.843 79.6617 26.843C80.29 26.843 80.8224 27.1663 81.0004 27.6292L77.7761 29.0055ZM73.8566 32.6H75.4403V21.7039H73.8566V32.6ZM71.2605 26.2389H71.2062C70.851 25.8031 70.1677 25.41 69.3079 25.41C67.5046 25.41 65.8522 27.0391 65.8522 29.1318C65.8522 31.2098 67.5046 32.8249 69.3079 32.8249C70.1685 32.8249 70.851 32.4318 71.2062 31.9829H71.2605V32.5163C71.2605 33.9344 70.5229 34.6928 69.3351 34.6928C68.3652 34.6928 67.764 33.9772 67.5182 33.3731L66.1387 33.9632C66.5347 34.9455 67.586 36.1536 69.3351 36.1536C71.1927 36.1536 72.7637 35.0301 72.7637 32.2914V25.6358H71.2614L71.2605 26.2389ZM69.4444 31.3649C68.3516 31.3649 67.4368 30.4236 67.4368 29.1318C67.4368 27.8253 68.3516 26.8709 69.4444 26.8709C70.5229 26.8709 71.3699 27.8253 71.3699 29.1318C71.3699 30.4236 70.5229 31.3649 69.4444 31.3649ZM90.1155 21.7039H86.3248V32.6H87.9061V28.472H90.1147C91.868 28.472 93.5925 27.1672 93.5925 25.0884C93.5925 23.0096 91.8688 21.7039 90.1155 21.7039ZM90.1562 26.9554H87.9061V23.2205H90.1562C91.3389 23.2205 92.0104 24.2272 92.0104 25.0884C92.0104 25.9321 91.3389 26.9554 90.1562 26.9554ZM99.9334 25.3909C98.788 25.3909 97.6019 25.9095 97.111 27.0591L98.515 27.6614C98.8152 27.0591 99.3747 26.8621 99.9606 26.8621C100.779 26.8621 101.61 27.3668 101.624 28.2637V28.3761C101.337 28.2079 100.724 27.956 99.9741 27.956C98.4608 27.956 96.9194 28.8111 96.9194 30.4088C96.9194 31.867 98.1606 32.8057 99.5511 32.8057C100.614 32.8057 101.201 32.315 101.569 31.7397H101.623V32.5808H103.151V28.4032C103.152 26.4699 101.746 25.3909 99.9334 25.3909ZM99.7418 31.3623C99.2247 31.3623 98.5015 31.0956 98.5015 30.4366C98.5015 29.5955 99.4019 29.273 100.179 29.273C100.874 29.273 101.202 29.4273 101.624 29.6374C101.501 30.6476 100.656 31.3623 99.7418 31.3623ZM108.714 25.6288L106.901 30.353H106.847L104.965 25.6288H103.26L106.083 32.2313L104.474 35.9043H106.123L110.474 25.6288H108.714ZM94.4658 32.6H96.047V21.7039H94.4658V32.6Z",
    fill: "#0A1853"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0817 15.2589C44.0817 15.976 43.8716 16.5469 43.4507 16.9731C42.9729 17.4797 42.3495 17.7331 41.5837 17.7331C40.8501 17.7331 40.2258 17.4763 39.7134 16.9628C39.2 16.4485 38.9434 15.8117 38.9434 15.0518C38.9434 14.2909 39.2 13.6542 39.7134 13.1407C40.2258 12.6263 40.8501 12.3696 41.5837 12.3696C41.9479 12.3696 42.2961 12.4415 42.6264 12.5844C42.9577 12.7282 43.2228 12.919 43.421 13.1578L42.9746 13.6097C42.6383 13.2032 42.175 13.0003 41.5828 13.0003C41.0475 13.0003 40.585 13.1903 40.1945 13.5703C39.804 13.9503 39.6092 14.4441 39.6092 15.0509C39.6092 15.6577 39.804 16.1515 40.1945 16.5315C40.585 16.9115 41.0475 17.1015 41.5828 17.1015C42.1504 17.1015 42.6239 16.9106 43.0025 16.5281C43.2482 16.279 43.3905 15.9324 43.4286 15.4882H41.5828V14.8712H44.0453C44.0707 15.0055 44.0817 15.1348 44.0817 15.2589Z",
    fill: "#0A1853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9868 13.1142H45.6726V14.742H47.7598V15.359H45.6726V16.9868H47.9868V17.6184H45.0195V12.4835H47.9868V13.1142Z",
    fill: "#0A1853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7406 17.6184H50.0875V13.1142H48.6678V12.4835H52.1603V13.1142H50.7406V17.6184Z",
    fill: "#0A1853"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6871 17.6184V12.4835H55.3402V17.6184H54.6871Z",
    fill: "#0A1853"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2365 17.6184H57.5834V13.1142H56.1637V12.4835H59.6562V13.1142H58.2365V17.6184Z",
    fill: "#0A1853"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2674 16.9551C65.7676 17.4738 65.1467 17.7331 64.4038 17.7331C63.6609 17.7331 63.04 17.4738 62.5411 16.9551C62.0413 16.4365 61.7923 15.8015 61.7923 15.0509C61.7923 14.3004 62.0413 13.6654 62.5411 13.1467C63.04 12.6281 63.6609 12.3679 64.4038 12.3679C65.1425 12.3679 65.7625 12.6289 66.264 13.1501C66.7655 13.6713 67.0162 14.3047 67.0162 15.0509C67.0162 15.8015 66.7663 16.4365 66.2674 16.9551ZM63.0231 16.5247C63.3992 16.9098 63.8591 17.1015 64.4038 17.1015C64.9485 17.1015 65.4093 16.9089 65.7846 16.5247C66.1607 16.1395 66.3496 15.6483 66.3496 15.0509C66.3496 14.4536 66.1607 13.9623 65.7846 13.5772C65.4093 13.1921 64.9485 13.0004 64.4038 13.0004C63.8591 13.0004 63.3992 13.1929 63.0231 13.5772C62.6478 13.9623 62.4589 14.4536 62.4589 15.0509C62.4589 15.6483 62.6478 16.1395 63.0231 16.5247Z",
    fill: "#0A1853"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9328 17.6184V12.4835H68.7273L71.1974 16.4776H71.2253L71.1974 15.4883V12.4835H71.8505V17.6184H71.1686L68.5842 13.43H68.5562L68.5842 14.4193V17.6184H67.9328Z",
    fill: "#0A1853"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0817 15.2589C44.0817 15.976 43.8716 16.5469 43.4507 16.9731C42.9729 17.4797 42.3495 17.7331 41.5837 17.7331C40.8501 17.7331 40.2258 17.4763 39.7134 16.9628C39.2 16.4485 38.9434 15.8117 38.9434 15.0518C38.9434 14.2909 39.2 13.6542 39.7134 13.1407C40.2258 12.6263 40.8501 12.3696 41.5837 12.3696C41.9479 12.3696 42.2961 12.4415 42.6264 12.5844C42.9577 12.7282 43.2228 12.919 43.421 13.1578L42.9746 13.6097C42.6383 13.2032 42.175 13.0003 41.5828 13.0003C41.0475 13.0003 40.585 13.1903 40.1945 13.5703C39.804 13.9503 39.6092 14.4441 39.6092 15.0509C39.6092 15.6577 39.804 16.1515 40.1945 16.5315C40.585 16.9115 41.0475 17.1015 41.5828 17.1015C42.1504 17.1015 42.6239 16.9106 43.0025 16.5281C43.2482 16.279 43.3905 15.9324 43.4286 15.4882H41.5828V14.8712H44.0453C44.0707 15.0055 44.0817 15.1348 44.0817 15.2589Z",
    stroke: "#0A1853",
    strokeWidth: 0.0347743,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9868 13.1142H45.6726V14.742H47.7598V15.359H45.6726V16.9868H47.9868V17.6184H45.0195V12.4835H47.9868V13.1142Z",
    stroke: "#0A1853",
    strokeWidth: 0.0347743,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7406 17.6184H50.0875V13.1142H48.6678V12.4835H52.1603V13.1142H50.7406V17.6184Z",
    stroke: "#0A1853",
    strokeWidth: 0.0347743,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6871 17.6184V12.4835H55.3402V17.6184H54.6871Z",
    stroke: "#0A1853",
    strokeWidth: 0.0347743,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2365 17.6184H57.5834V13.1142H56.1637V12.4835H59.6562V13.1142H58.2365V17.6184Z",
    stroke: "#0A1853",
    strokeWidth: 0.0347743,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2674 16.9551C65.7676 17.4738 65.1467 17.7331 64.4038 17.7331C63.6609 17.7331 63.04 17.4738 62.5411 16.9551C62.0413 16.4365 61.7923 15.8015 61.7923 15.0509C61.7923 14.3004 62.0413 13.6654 62.5411 13.1467C63.04 12.6281 63.6609 12.3679 64.4038 12.3679C65.1425 12.3679 65.7625 12.6289 66.264 13.1501C66.7655 13.6713 67.0162 14.3047 67.0162 15.0509C67.0162 15.8015 66.7663 16.4365 66.2674 16.9551ZM63.0231 16.5247C63.3992 16.9098 63.8591 17.1015 64.4038 17.1015C64.9485 17.1015 65.4093 16.9089 65.7846 16.5247C66.1607 16.1395 66.3496 15.6483 66.3496 15.0509C66.3496 14.4536 66.1607 13.9623 65.7846 13.5772C65.4093 13.1921 64.9485 13.0004 64.4038 13.0004C63.8591 13.0004 63.3992 13.1929 63.0231 13.5772C62.6478 13.9623 62.4589 14.4536 62.4589 15.0509C62.4589 15.6483 62.6478 16.1395 63.0231 16.5247Z",
    stroke: "#0A1853",
    strokeWidth: 0.0347743,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9328 17.6184V12.4835H68.7273L71.1974 16.4776H71.2253L71.1974 15.4883V12.4835H71.8505V17.6184H71.1686L68.5842 13.43H68.5562L68.5842 14.4193V17.6184H67.9328Z",
    stroke: "#0A1853",
    strokeWidth: 0.0347743,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_481_2889",
    x: 12.6699,
    y: 12.3679,
    width: 20.7275,
    height: 23.8413,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.135179
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_481_2889"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.135179
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_481_2889",
    result: "effect2_innerShadow_481_2889"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_481_2889",
    x: 13.085,
    y: 24.2882,
    width: 14.9785,
    height: 11.921,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.135179
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_481_2889"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.44ec3869581dcb1cf6a53594931e8e35.svg";
export { ForwardRef as ReactComponent };